export const LocalStorageKeys = {
    Lang: "Lang",
    AuthToken: "authToken",
    RefreshToken: "refreshToken",
    UserDetails: "userDetails",
    UniqueId: "uniqueId",
    ThemeMode: "themeMode",
}